module.exports = __webpack_public_path__ + "img/x5.5e13b051.jpg";